import _ from 'lodash';
import phantom from '../../services/phantom';

// 
// Action types
// 

export const SET_REPORT_DATE_RANGE_FILTER = 'SET_REPORT_DATE_RANGE_FILTER';
export const SET_REPORT_DEVICES_FILTER = 'SET_REPORT_DEVICES_FILTER';
export const SET_REPORT_TAGS_FILTER = 'SET_REPORT_TAGS_FILTER';
export const SET_REPORT_QUESTION_FILTER = 'SET_REPORT_QUESTION_FILTER';
export const RESET_REPORT_WIDGETS_LOADING_STATE = 'RESET_REPORT_WIDGETS_LOADING_STATE';
export const SET_REPORT_WIDGET_LOADING_STATE = 'SET_REPORT_WIDGET_LOADING_STATE';
export const SET_REPORT_WIDGET_LOADING_STATE_AND_NOTIFY_PHANTOM = 'SET_REPORT_WIDGET_LOADING_STATE_AND_NOTIFY_PHANTOM';

// 
// Action creators
// 

export function setReportDateRangeFilter(reportId, dateRange) {
  return {
    type: SET_REPORT_DATE_RANGE_FILTER,
    reportId,
    dateRange,
  };
};

export function setReportDevicesFilter(reportId, deviceIds) {
  return {
    type: SET_REPORT_DEVICES_FILTER,
    reportId,
    deviceIds,
  };
};

export function setReportTagsFilter(reportId, deviceIdsByTags) {
  return {
    type: SET_REPORT_TAGS_FILTER,
    reportId,
    deviceIdsByTags,
  };
};

export function setReportQuestionFilter(reportId, questionId, options) {
  return {
    type: SET_REPORT_QUESTION_FILTER,
    reportId,
    questionId,
    options,
  };
}

export function resetReportWidgetsLoadingState(reportId, widgetIds) {
  return {
    type: RESET_REPORT_WIDGETS_LOADING_STATE,
    reportId,
    widgetIds,
  };
};

export function setReportWidgetLoadingState(reportId, widgetId, loaded) {
  return {
    type: SET_REPORT_WIDGET_LOADING_STATE,
    reportId,
    widgetId,
    loaded,
  };
}

export function setReportWidgetLoadingStateAndNotifyPhantom(reportId, widgetId, loaded) {
  return (dispatch, getState) => {
    const reports = getState().reports || [];
    const report = _.find(reports, {id: reportId});
    const widgets = report.widgets || [];
    const loadingWidgets = widgets.filter(widget => !widget.loaded);

    if (
      loadingWidgets.length === 0 ||
      (loadingWidgets.length === 1 && loadingWidgets[0].id === widgetId)
    ) {
      phantom.reportLoaded();
    }

    dispatch(setReportWidgetLoadingState(reportId, widgetId, loaded));
  };
}



// WEBPACK FOOTER //
// ./src/services/redux/actions.js